export const marketingActions = {
  'german.collection.click': {
    eventType: 'engagement',
    entityTypes: ['ui'],
    eventData: {
      uiType: 'button'
    },
    description: 'Banner at top of My List - die Collection von Tijen Onaran'
  },
  'german.collection.impression': {
    eventType: 'impression',
    entityTypes: ['ui'],
    eventData: {
      component: 'ui',
      uiType: 'button'
    },
    description: 'Banner at top of My List - die Collection von Tijen Onaran'
  }
}
